(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.property.pdf
  (:require
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.pdf :as esg]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as pdf-page]
   [frontend.ui.component.lp-portal.table.pdf.view :as pdf-table]))

(defn overview-pages
  [report-data]
  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title (:holding-name report-data) :toc-item true})
    (column/columns-2-to-1
     (card/card
      "Investment rationale"
      (text-content/rich-content (->> report-data
                                      :investment-rationale-text
                                      :rich-content)))
     {:margin [0 15 0 0]
      :stack  [(pdf-table/dynamic-stack (->> report-data
                                             :overview
                                             :figures
                                             (pdf-table/limit-dynamic-stack)))
               (text-content/optional-footer (->> report-data
                                                  :overview))]}))
   (page/page
    (page/third-column-background)
    (page/page-title {:page-title (:holding-name report-data)})
    (column/columns-2-to-1
     (card/card
      "Business plan"
      (text-content/rich-content (->> report-data
                                      :business-plan-text
                                      :rich-content)))
     {:margin [0 15 0 0]
      :stack  [(pdf-table/dynamic-stack (->> report-data
                                             :overview
                                             :figures
                                             (pdf-table/continue-dynamic-stack)))
               (text-content/optional-footer (->> report-data
                                                  :overview))
               (card/card
                "Locations"
                {:svg   (chart-view/geomap-svg "highcharts"
                                               (potpuri/deep-merge
                                                (:figures (:map-data report-data))
                                                #_{:chart {:width  500
                                                           :height 350}}))
                 :width (- pdf-page/page-width-one-third 52)}
                (text-content/optional-footer (:map-data report-data)))]}))
   (page/page
    nil
    (page/page-title {:page-title (:holding-name report-data)})
    (column/columns (card/card
                     "Asset management update"
                     (text-content/rich-content (->> report-data
                                                     :access-management-update-text
                                                     :rich-content)))
                    #_(column/column
                       (card/card
                        "Sustainability"
                        (text-content/rich-content (->> report-data
                                                        :esg-text
                                                        :rich-content))))))
   (page/page
    nil
    (page/page-title {:page-title (:holding-name report-data)})
    (column/columns
     (column/column
      (card/card
       "Gross investment at cost & valuation"
       {:svg   (chart-view/chart-svg "highcharts"
                                     (potpuri/deep-merge
                                      (-> report-data
                                          :investment-at-cost-and-valuation
                                          :figures)
                                      {:chart {:width  500
                                               :height 400}}))
        :width (- page/page-width-half 46)}))
     (column/column
      (card/card
       "NOI"
       {:svg   (chart-view/chart-svg "highcharts"
                                     (potpuri/deep-merge
                                      (-> report-data
                                          :noi
                                          :figures)
                                      {:chart {:width  500
                                               :height 400}}))
        :width (- page/page-width-half 46)}))))])

(defn holding-pages
  [view-data]
  (overview-pages view-data))


(defn holding-pages-esg
  [view-data]
  (concat (overview-pages view-data)
          (esg/esg-pages view-data)))

(defn holding-pages-portfolio-esg
  [view-data]
  (concat (overview-pages view-data)
          (esg/portfolio-esg-pages view-data)))
